import React from 'react';

// Message d'aide court sous un champ (.mkt-hint), avec une tonalité optionnelle.
type HintTone = 'neutral' | 'ok' | 'err';

interface HintProps {
  tone?: HintTone;
  children: React.ReactNode;
}

const Hint: React.FC<HintProps> = ({ tone = 'neutral', children }) => {
  const classes = ['mkt-hint', tone === 'ok' ? 'ok' : '', tone === 'err' ? 'err' : '']
    .filter(Boolean)
    .join(' ');
  return <p className={classes}>{children}</p>;
};

export default Hint;
